import { DataTable } from '../../components/admin/data-table';
import { ReferenceField } from '../../components/admin/reference-field';
import { TextField } from '../../components/admin/text-field';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { MoonstarListBulkActions } from '../Moonstar/MoonstarListBulkActions';

export const TopicList = () => (
  <MoonstarList sort={{ field: 'displayName', order: 'ASC' }}>
    <DataTable rowClick="edit" bulkActionButtons={<MoonstarListBulkActions />}>
      <DataTable.Col source="displayName" />
      <DataTable.Col source="formTypeId" disableSort>
        <ReferenceField source="formTypeId" reference="formTypes" link={false}>
          <TextField source="typeName" />
        </ReferenceField>
      </DataTable.Col>
    </DataTable>
  </MoonstarList>
);
